module.exports = __webpack_public_path__ + "img/jf6.5da33e56.png";